import FormHelperText from "@mui/material/FormHelperText"

export interface FormErrorsProps {
  errors: string[]
}

export const FormErrors = ({ errors }: FormErrorsProps) => {
  if (errors.length === 0) {
    return null
  }

  if (errors.length === 1) {
    return (
      <FormHelperText error={true} sx={{ margin: 0 }}>
        {errors[0]}
      </FormHelperText>
    )
  }

  return (
    <FormHelperText
      error={true}
      component={"ul"}
      sx={{ paddingLeft: 0, my: 0, listStylePosition: "inside" }}
    >
      {errors.map((error) => (
        <li key={error}>{error}</li>
      ))}
    </FormHelperText>
  )
}
